<template>
	<div class="root">
		<MeetingHeader/>
		<div class="container">
			<TopBar style='padding: 0 10px'/>
			<div class="title">{{store.StoreName}}/{{room.Name}}</div>
			<div class='top-btns'>
				<Button size='large' type='primary' class='btn-prev' @click='prevMonth' :disabled='disabledPrev'><Icon size='17' type="ios-arrow-back" />上个月</Button>
				<p class="cur-date">{{this.getYearMonth()}}</p>
				<Button size='large' type='primary' class='btn-next' @click='nextMonth' :disabled='!disabledPrev'>下个月<Icon size='17' type="ios-arrow-forward" /></Button>
			</div>
			<table class="calendar" border='1' cellspacing="0">
				<tr class="weeks">
					<th class="weekday" v-for='item in weeks'>{{item}}</th>
				</tr>
				<tr class="days" v-for='row in parseInt(days.length/7)'>
					<td v-for='column in 7'>
						<Day 
							:day='day(row,column)' 
							:events='getEvents(day(row,column))'
							:serve-time="serveTime"
							:selectedDay='selectedDay' 
							@selectDay='selectDay' 
							@selectEvent='selectEvent'
						/>
					</td>
				</tr>
			</table>
			<div class="events sm-events" v-if='selectedDay.key'>
				<div class="event" @click='selectEvent(event,selectedDay)' :class='{passed:isPassed(selectedDay.date,event,serveTime),disabledApplyed:event.RoomStatus.toLowerCase() == "forbid"||selectedDay.date.getDay() == 0,applyed:event.RoomStatus.toLowerCase() == "otherreserved","self-applyed":event.RoomStatus.toLowerCase() == "myreserved"}' v-for='event in getEvents(selectedDay)'>
					<div class="time-slot">{{event.BeginTime}}-{{event.EndTime}}</div>
					<div class="status">{{getRoomStatus(event.RoomStatus,selectedDay.date)}}</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import MeetingHeader from '@/components/header/MeetingHeader'
	import TopBar from '@/components/common/TopBar'
	import Day from './Day'
	import util from '@/config/util'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import {baseMixins} from './baseMixins'
	export default {
		data() {
			return {
				weeks:['星期日','星期一','星期二','星期三','星期四','星期五','星期六',],
				month:new Date(),
				selectedDay:{},
				days:[],
				disabledPrev:true,
				events:{},
				room:{},
				loading:false,
				// visiable:true,
				serveTime: new Date(),
				orderTime7: '',
				orderTime9: '',
				orderHour: ''
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[baseMixins],
		components: {
			MeetingHeader,
			Day,
			TopBar,
		},
		computed: {
			...mapState({
				stores:state=>state.shmeeting.stores
			}),
			store() {
				return this.stores.filter(item=>item.StoreId == this.$route.query?.storeId)[0]
			}
		},
		methods: {
			...mapActions([
				'getReservationCalendarAction',
				'postReservationRoomsAction',
				'getMeetingRoomAction',
				'getUserRankAction',
				'getMeetingOrderTimeAction'
			]),
			day(row,column){
				return this.days[7 * (row - 1) + column-1]
			},
			selectDay(day) {
				if (day.date.getMonth() ==  this.month.getMonth()) {
					this.selectedDay = day
				}
			},
			getYearMonth(){
				return util.formatDate.format(this.month,'yyyy-MM')
			},
			getEvents(day){
				let key = util.formatDate.format(day.date,'yyyy-MM-dd')
				return this.events[key]
			},
			async initData(){
				this.month = await this.getServeTime()
				this.serveTime = this.month
				this.orderTime7 = await this.getMeetingOrderTimeAction({ParentCode: 'dt_ss_roomorder_time',Code: 'rank7'})
				this.orderTime9 = await this.getMeetingOrderTimeAction({ParentCode: 'dt_ss_roomorder_time',Code: 'rank9'})
				this.orderHour = await this.getMeetingOrderTimeAction({ParentCode: 'dt_ss_roomorder_time',Code: 'hour'})
				if (!this.stores?.length) {
					await this.getStoresAction()
				}
				this.days = await this.configCalendarDates(this.serveTime.getFullYear(),this.serveTime.getMonth())
				this.configEvents();
				let room = this.getParams()?.room || {}
				if (!room.ID) {
					room = await this.getMeetingRoomAction({roomId:this.$route.query?.roomId,})
				}
				this.room = room
			},
			async configEvents(){
				let response = await this.getReservationCalendarAction({
					RoomId:this.$route.query?.roomId,
					Month:this.getYearMonth()
				})
				let events = {}
				response.forEach(item=>{
					if (events[item.BookingDate]) {
						events[item.BookingDate].push(item)
					} else {
						events[item.BookingDate] = [item]
					}
				})
				this.events = events
			},
			async prevMonth() {
				this.disabledPrev = !this.disabledPrev
				let year = this.month.getFullYear(),month = this.month.getMonth() - 1
				this.month = new Date(year,month,this.month.getDate())
				this.days = await this.configCalendarDates(year,month)
				this.configEvents()
			},
			async nextMonth() {
				this.disabledPrev = !this.disabledPrev
				let year = this.month.getFullYear(),month = this.month.getMonth() + 1
				this.month = new Date(year,month,this.month.getDate())
				this.days = await this.configCalendarDates(year,month)
				this.configEvents()
			},
			mergeRoomData(room, event, Rooms) {
				// 取出room，并重命名Name为RoomName
				const { Name, ...roomRest } = room;
				const renamedRoom = {
					...roomRest,
					RoomName: Name,
					OrderStatus:'UnPay'
				};
				// 合并所有对象（后者覆盖前者）
				const merged = {
					...renamedRoom,
					...event,
					...(Rooms?.[0] || {})
				};
				return merged;
			},
			async configCalendarDates(year,month){
				let now  = await this.getServeTime()
				let firstDayofMonth = new Date(year,month,1)
				let lastDayofMonth = new Date(year,month+1,0)
				let firstDayWeekDay = firstDayofMonth.getDay()
				let lastDayWeekDay = lastDayofMonth.getDay()
				let startDay = new Date(year,month,1-firstDayWeekDay)
				let lastDay = new Date(year,month+1,7-lastDayWeekDay)
				let length = (lastDay - startDay) / 86400000
				let days = []
				for (let i = 0; i < length;i ++) {
					let date = new Date(startDay.getFullYear(),startDay.getMonth(),startDay.getDate()+i)
					let isToday = date.getFullYear() == now.getFullYear() && date.getMonth() == now.getMonth() && date.getDate() == now.getDate()
					let obj = {
						key:util.guid(),
						date,
						isCurMonth:date.getMonth() == month,
						isToday,
					}
					days.push(obj)
					if (isToday && !this.selectedDay.key) this.selectedDay = obj
				}
				return days
			},
			async selectEvent(event,day){
				if (this.loading) return;
				let now = await this.getServeTime()
				let roomStatus = event.RoomStatus.toLowerCase()
				if (this.isPassed(day.date,event,now) || roomStatus == 'forbid' || day.date.getDay() == 0) return
				if (roomStatus != "freeroom") {
					this.$Modal.info({
						title:'提示',
						content:'该时间段已被预约',
					})
					return
				}
				if ((now.getDate() < this.orderTime9 || (now.getDate() == this.orderTime9 && now.getHours() < this.orderHour)) && day.date.getMonth() != now.getMonth()) {
					this.$Modal.info({
						title:'提示',
						content:`${this.orderTime9}号${this.orderHour}点后才能预约${day.date.getMonth()+1}月的会议室`,
					})
					return
				}
				const result = await this.getUserRankAction()
				const [{Rank}] = result.data.value
				if ((day.date.getMonth() > now.getMonth()) || (day.date.getMonth() === 0 && now.getMonth() === 11)) {
					const checkCode = this.checkRank(Rank,this.orderTime9,this.orderTime7,this.orderHour,this.orderHour,now)
					if (checkCode === 0) {
						this.$Modal.info({
							title:'提示',
							content:`当前职级需${this.orderTime7}号${this.orderHour}点才能预约`,
						})
						return
					}
				}
				let Rooms = [{
					IsRoom:1,
					RoomId:event.RoomId,
					ProductId:0,
					Price:this.room.Price,
					Qty:1,
					Amount:this.room.Price,
					Discount:0,
					BookingDate:event.BookingDate,
					TimeRangeId:event.TimeRangeId,
				}]
				let Amount = Rooms.reduce((prev,cur)=>{
					return prev + cur.Price
				}, 0)
				let params = {
					StoreId:this.$route.query?.storeId,
					OrderStatus:'UnPay',
					Amount,
					TotalPaid:Amount,
					Discount:0,
					Rooms,
					place:'calendar',
				}
				if (!Rooms.length) {
					this.$Modal.info({
						title:'提示',
						content:"请勾选预约时间"
					})
					return
				}
				const checkRooms = this.mergeRoomData(this.room, event, Rooms);
				sessionStorage.setItem('checkRooms', JSON.stringify([checkRooms]));
				this.$router.push(`/meeting/confirm?storeId=${this.$route.query?.storeId}`)
				return
				this.loading = true
				let response = await this.postReservationRoomsAction(params)
				this.loading = false
				if (typeof response?.Value == 'string') {
					this.$Modal.error({
						title:'提示',
						content:response?.Value,
					})
				} else if(response == -1) {
					this.$Modal.error({
						title:'错误',
						content:'提交异常，请稍后重试',
					})
				} else {
					this.$router.push(`/meeting/confirm?code=${response?.Value}`)
				}
				
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1rem;
		margin:0 auto;
		max-width: 1400px;
		width:100%;
		display:block;
	}
	.title {
		margin-top:20px;
		color:$theme-color;
		@include fontSize($font-size-24);
	}
	.top-btns {
		display:flex;
		align-items: center;
		justify-content: center;

		.btn-prev,.btn-next {
			border-radius: 20px;
		}
		.cur-date {
			margin:0 20px;
		}
	}
	.calendar {
		width:100%;
		border-color: #ccc;
		border-collapse:collapse;
		background-color:white;
		margin:30px 0;
		.weeks {
			.weekday {
				padding:10px 0;
			}
			
		}
		.days {
			td {
				height:14.285714286em;
			}
		}
	}
	.events {
		margin-top: 10px;
		.event {
			display:flex;
			justify-content: space-between;
			background-color:$green;
			margin-bottom: 10px;
			padding:5px 10px;
			border-radius: 20px;
			color:white;
			cursor: pointer;
		}
		.passed {
			background-color:gray;
			// visibility: hidden;
		}
		.disabledApplyed {
			background-color:gray;
		}
		.self-applyed {
			background-color:$theme-color;
		}
		.applyed {
			background-color: red;
		}

	}
	.sm-events {
		display:none;
	}
	@media (max-width: 768px){
		.title {
			margin-top:20px;
			color:$theme-color;
			font-size: 17px;
			margin-bottom: 15px;
			margin-left: 15px;
		}
		.container {
			padding-top: 2.4rem;
			background-color:white;
			flex:1
		}
		.calendar {
			margin-bottom: 0;
			.days {
				td {
					height:14.285714286vw;
					.events {
						display:none;
						justify-content: space-around;
						.event {
							padding:5px;
							.time-slot,.status {
								display:none;
							}
						}
					}
				}
			}
		}
		.sm-events {
			display:block;
			margin-top: 0;
			padding:30px 10px;
		}
	}
</style>